export const wrapperWidth = '1400px';
export const containerWidth = '1280px';
export const contentWidth = '1000px';
export const textWidth = '520px';
